/** EXPERIMENTAL - USE AT YOUR OWN RISK - API might change */
import * as ui from "../../ui";
import {Dialog, TreeViewNode} from "../widgets";
import {IDartApi} from "../api/grok_api.g";
const api: IDartApi = <any>window;


/** EXPERIMENTAL - USE AT YOUR OWN RISK - API might change */
export namespace x {

  export interface TreeViewConstructionOptions {

  }
}